import { cva } from 'class-variance-authority'

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        // ============================================
        // VARIANTS - Uses semantic tokens
        // ============================================

        // Primary - Main action button
        default:
          'h-[40px] px-4 gap-3 text-sm font-semibold bg-action-primary-bg text-action-primary-text border-0 rounded hover:bg-action-primary-hover disabled:opacity-55 disabled:cursor-not-allowed',

        // Destructive - Destructive actions (leave button)
        destructive:
          'bg-destructive text-white hover:bg-destructive/80 hover:scale-105 transition-all duration-200 disabled:cursor-not-allowed disabled:hover:scale-100',

        // Outline - Secondary button with border
        outline:
          'h-[44px] px-4 gap-3 text-xs font-bold text-primary bg-surface-primary border border-primary rounded hover:bg-accent disabled:opacity-50',

        // Secondary - Custom secondary button
        secondary:
          'h-[44px] p-3 gap-2 text-base leading-[22px] font-medium bg-grey-300 text-action-secondary-text rounded-xl hover:bg-action-secondary-hover-bg hover:text-action-secondary-hover-text hover:border-action-secondary-hover-border disabled:opacity-50 disabled:cursor-not-allowed',

        // Ghost - Transparent style
        ghost: 'h-[44px] px-4 gap-3 text-xs font-bold hover:bg-surface-tertiary hover:text-foreground rounded',

        // Link - Link style
        link: 'text-sm text-primary underline underline-offset-4',

        // ============================================
        // MEETING CONTROLS - Video control buttons
        // ============================================
        control:
          'bg-surface-medium text-inverse hover:bg-surface-medium/80 hover:scale-105 transition-all duration-200',
        videoControl:
          'h-14 w-14 bg-surface-primary text-foreground shadow-2xl ring-2 ring-white/20 backdrop-blur-sm hover:bg-surface-primary hover:shadow-xl hover:scale-105 hover:ring-white/40 disabled:opacity-50 disabled:hover:scale-100 transition-all duration-200'
      },
      size: {
        default: 'h-[40px] px-4 py-2',
        sm: 'h-8 px-3 text-xs',
        // Sizes coming from the SCSS mixin
        lg: 'px-[2.7rem] py-[1.6rem] text-[1.1rem]',
        md: 'px-[1.15rem] py-[0.6rem] text-[1.1rem]',
        icon: 'h-[44px] w-9',
        controlIcon: 'h-14 w-14',
        // PrimaryButton sizes
        smaller: 'h-[30px] px-4 gap-[10px] text-xs font-semibold',
        onlyIcon: 'h-[48px] w-[48px] p-0',
        // SecondaryButton sizes
        secondarySmaller: 'h-[34px] px-4 gap-3 text-xs font-semibold'
      },
      shape: {
        default: 'rounded-lg',
        rounded: 'rounded-lg',
        full: 'rounded-full',
        square: 'rounded-none'
      },
      active: {
        true: '',
        false: ''
      }
    },
    compoundVariants: [
      {
        variant: 'control',
        active: true,
        className: 'bg-surface-medium text-inverse hover:bg-surface-medium/90'
      }
    ],
    defaultVariants: {
      variant: 'default',
      size: 'default',
      shape: 'default',
      active: false
    }
  }
)
